<template>
    <div>
        <div class="row">
            <div class="col">
                <h3 class="sectionTitle">{{ $t('common.reservation.travelDates') }}</h3>
            </div>
        </div>
        <div class="row">
            <div class="d-flex col justify-content-center">
                <CoreDatePicker
                    v-model="selectedDates"
                    :columns="$screens({ default: 1, lg: 3 })"
                    :rows="$screens({ default: 1})" 
                >
                </CoreDatePicker>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <Toggle 
                    :title="$t('common.reservation.specialOffersOnly')" 
                    v-model="specialOffer" 
                    style="margin-top: 12px; margin-bottom: 12px; margin-left: 8px"
                />
            </div>
        </div>
    </div>

    
</template>

<script>
import CoreDatePicker from "@/components/common/datepicker/CoreDatePicker";
import Toggle from "@/components/common/Toggle";

export default {
    name: "DatePicker",
    components: {
        CoreDatePicker,
        Toggle
    },
    computed: {
        query: function() {
            return this.$store.getters.getQuery;
        },
        selectedDates: {
            get() {
                return this.query.selectedDates;
            },
            set(val) {
                let query = this.query;
                query.selectedDates = val;
                this.$store.commit('setQuery', query)
            }
        },
        specialOffer: {
            get() {
                return this.$store.getters.getQuery.specialOffer
            },
            set(val) {
                // get the query
                let query = this.$store.getters.getQuery;
                // Get the copy
                let newQuery = this.getEditable(query);

                // set the val
                newQuery.specialOffer = val;

                // Set it as the new query
                this.$store.commit('setQuery', newQuery);
            }
        }
    }
        
}
</script>